import React from "react";

import { CircularProgress } from "@material-ui/core";
import styled, { keyframes } from "styled-components";
import MicIcon from "@material-ui/icons/Mic";
import { VolumeHigh } from "mdi-material-ui";

const slide = keyframes`
    from {
      box-shadow: inset 0 100px 0 0  rgba(222,222,222,1);
    }
    to {
      box-shadow: inset 0 100px 0 0  rgba(0, 0 , 0, 0);
    }
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const Rotate = styled.div`
  display: inline-block;
  position: relative;
  animation: ${rotate} 2s linear infinite;
  // animation: ${slide} 2s  infinite;
  width: 100%;
  padding: 5px;
  height: 100%;
  // border-radius: 50%;
  font-size: 1.2rem;
`;

const pulse = keyframes`
  0% {
      box-shadow: 0 0 0 0px rgba(61, 151, 230, 0.3);
  }
  100% {
      box-shadow: 0 0 0 25px rgba(0, 0, 0, 0);
  }
`;

const Pulse = styled.div`
  display: inline-block;
  position: relative;
  animation: ${pulse} 3s infinite;
  width: 100%;
  // padding: 5px;
  height: 100%;
  border-radius: 50%;
  font-size: 1.2rem;
`;

class MicListeningBtn extends React.Component {
  constructor(props) {
    super(props);
  }

  gradientBackground() {
    if (this.props.recording) {
      return "linear-gradient(to right, rgba(77,243,255,1) 0%, rgba(68,189,241,1) 21%, rgba(66,179,238,1) 25%, rgba(61,151,230,1) 50%, rgba(66,179,238,1) 75%, rgba(66,182,239,1) 76%, rgba(77,243,255,1) 100%)";
    } else {
      return "#3d97e6";
    }
  }

  whiteBackground() {
    if (this.props.recording) {
      return "#fff";
    } else {
      return "#f4f7f9";
    }
  }

  micColor() {
    if (this.props.recording) {
      return "red";
    } else {
      return "#535353";
    }
  }

  render() {
    const box = {
      position: "relative",
      width: "46px",
      height: "46px"
    };

    let bottom = {
      position: "absolute",
      top: 0,
      left: 0,
      width: "46px",
      height: "46px",
      background: this.gradientBackground(),
      borderRadius: "50%",
      display: "flex",
      flex: "0 1 100%",
      justifyContent: "center",
      alignItems: "center",
      alignContent: "stretch",
      transition: "1s"
    };

    const top = {
      position: "absolute",
      top: "6px",
      left: "6px",
      width: "34px",
      height: "34px",
      borderRadius: "50%",
      backgroundColor: this.props.recording ? "#fff" : "#f4f7f9",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    };

    const mic = {
      color: this.micColor()
    };

    const speaker = {
      color: "#3d97e6"
    };

    // console.log("____________________________________________");
    // console.log("Recording: ", this.props.recording);
    // console.log("Stream: ", this.props.recording);
    // console.log("ContinuousRecording: ", this.props.recording);
    // console.log("listeningState: ", this.props.listeningState);

    let microphone = (
      <div style={box}>
        {/*<CircularProgress size={46} />*/}

        <Rotate>
          <div style={bottom} />
        </Rotate>

        <div style={top}>
          <MicIcon style={mic} />
        </div>
      </div>
    );

    switch (this.props.listeningState) {
      case "PASSIVE":
        microphone = microphone;
        break;

      case "RECORDING":
        microphone = microphone;
        break;

      case "SENDING":
        microphone = (
          <div style={box}>
            <CircularProgress size={46} thickness={6} style={{ color: "#3d97e6" }} />

            <div style={top}>
              <MicIcon style={mic} />
            </div>
          </div>
        );
        break;

      case "PLAYING":
        microphone = (
          <div style={box}>
            <Pulse>
              <Pulse style={{ animationDelay: "1s" }}>
                <Pulse style={{ animationDelay: "2s" }}>
                  <div style={bottom} />
                </Pulse>
              </Pulse>
            </Pulse>

            <div style={top}>
              <VolumeHigh style={speaker} />
            </div>
          </div>
        );
        break;

      default:
        microphone = microphone;
    }

    return microphone;
  }
}

export default MicListeningBtn;
